var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('my-header'),_c('el-container',[_c('my-slide'),_c('el-main',[_c('bread'),_c('content-main'),_c('my-footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }